import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import _str from "shared/util/_str";
import useBoostCountdown from "shared/hooks/useBoostCountdown";
import FinishedBoostModal from "./FinishedBoostModal";
import ProgressBar from "shared/components/ProgressBar";
import BoostBoltIcon from "../icons/BoostBolt.svg";
import {
	selectedOptionOnNavBarEvent,
	selectedFirstPartyPromoEvent,
} from "../analytics";

import "./BoostButton.scss";

const DEFAULT_BOOST_MULTIPLIER = 1.1;

const BoostButton = ({
	isStaff,
	hasIncognitoEnabled,
	tokenCount,
	isBoosting,
	endTime,
	startTime,
	multiplier,
	isFinishedBoostModalOpen,
	closeFinishedBoostModal,

	startBoost,
	endBoost,
}) => {
	const onClickStartBoost = () => {
		startBoost();

		if (!tokenCount) {
			selectedOptionOnNavBarEvent("Boost Modal");
		}

		selectedFirstPartyPromoEvent("boost");
	};
	const onClickEndBoost = () => endBoost();
	const onClickedBoostAgain = () => {
		closeFinishedBoostModal();
		startBoost({ boostAgainCTA: true });
	};

	const {
		countdownTime,
		countdownProgress,
	} = useBoostCountdown({
		startTime,
		endTime,
	});

	const buttonDisplayText = (() => {
		if (isBoosting) {
			return countdownTime
				? `${multiplier || DEFAULT_BOOST_MULTIPLIER}x (${countdownTime})`
				: `${multiplier || DEFAULT_BOOST_MULTIPLIER}x`;
		} else if (tokenCount) {
			return _str(`Boost (${tokenCount})`);
		} else {
			return _str("GET BOOST");
		}
	})();

	return (
		<div className="navbar-boost">
			<button
				onClick={onClickStartBoost}
				className={classnames("navbar-boost-button", {
					disabled: hasIncognitoEnabled,
				})}
				disabled={hasIncognitoEnabled}
			>
				<div className="navbar-boost-button-inner-container">
					<BoostBoltIcon />
					<span className={classnames("navbar-boost-text", {
						"navbar-boost-text--boosting": isBoosting,
					})}>
						{buttonDisplayText}
					</span>
				</div>
			</button>
			{
				isBoosting && !!isStaff &&
				<button
					className="navbar-boost-cancel-button"
					onClick={onClickEndBoost}
				/>
			}
			{isBoosting &&
				<ProgressBar
					outerContainerClassName="navbar-boost-progress-container"
					progressPercentage={countdownProgress || "100%"}
					progressClassName="navbar-boost-progress-bar"
				/>
			}
			<FinishedBoostModal
				show={isFinishedBoostModalOpen}
				boostAgain={onClickedBoostAgain}
				onClose={closeFinishedBoostModal}
				viewMultiplier={multiplier}
			/>
		</div>
	);
};

BoostButton.defaultProps = {
	isStaff: false,
	tokenCount: 0,
	hasIncognitoEnabled: false,
	isBoosting: false,
	endTime: null,
	startTime: null,
	multiplier: 1.1,
	isFinishedBoostModalOpen: false,
};

BoostButton.propTypes = {
	isStaff: PropTypes.bool,
	tokenCount: PropTypes.number,
	hasIncognitoEnabled: PropTypes.bool,
	isBoosting: PropTypes.bool,
	endTime: PropTypes.number,
	startTime: PropTypes.number,
	multiplier: PropTypes.number,
	isFinishedBoostModalOpen: PropTypes.bool,
	closeFinishedBoostModal: PropTypes.func.isRequired,
	startBoost: PropTypes.func.isRequired,
	endBoost: PropTypes.func.isRequired,
};

export default BoostButton;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/BoostButton/BoostButton.jsx